/* eslint-disable react-hooks/rules-of-hooks */
import React, {
  Dispatch,
  MutableRefObject,
  useCallback,
  useContext,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

import CustomDatePicker from './partials/components/CustomDatePicker';
import { formatNumber } from 'utils/helper';
import NumberControl from './partials/components/NumberControl';
import GrandstandDiagram from './partials/components/GrandstandDiagram';
import { ReactComponent as TrashIcon } from 'app/assets/img/trash.svg';
import { StyledCheckbox } from '../TicketList';
import { I_CartItem } from '../../slice/types';
import { useGlobalFunction } from 'app/pages/App/hooks/useGlobalFunction';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { BP_TYPE, MAP_VGS, TICKET_TYPES } from 'utils/constants';
import useWindowSize from 'app/hooks/useWindowSize';
import { GET_TICKET_PRICE, cartActions } from '../../slice';
import { generateTicketIdentify } from '../../utils';
import DialogWarning from 'app/pages/Catalog/components/DialogWarning';
import { ReactComponent as ArrowDownIcon } from 'app/assets/img/arrow_down.svg';
import useGetUsedArea2 from 'app/hooks/useGetUsedArea2';
import {
  Catalog,
  ErrMess,
  ListedPrice,
  PositionAndTimeBlock,
  PriceBLock,
  PromotionalPrice,
  StyledDefaultImg,
  StyledSelect,
  Thumb,
  TicketContainer,
  TicketName,
  Time,
} from './partials/components/Styled';
import checkHaveTicketOnSelectedDate from './partials/helper';
import {
  OnMergeTicket,
  OnRemoveTicketList,
  OnSetCart,
  PaymentMethod,
} from '../../hooks/useCartNew';
import RenderIf from 'app/components/RenderIf';
import Inventory from './partials/components/Inventory';
import { FormCustomContext } from '../..';
import { useSearchParams } from 'utils/hooks/useSearchParams';
import { SelectPopupContainer } from 'app/pages/Catalog/FormItemTicket';
import { PriceDisplayStatus } from 'app/pages/Catalog/FormItemTicket';
import _ from 'lodash';
import { PriceWrapper } from 'app/pages/EditOrder/components/ShowItem';
import { getReservationBookingStoresApi } from 'app/services/reservationHistoryApi';
import { getBookingMethodArr } from 'app/pages/Restaurants/config';

export interface TicketItemProps extends I_CartItem {
  isSubmitted: boolean;
  onSetCart: OnSetCart;
  onMergeTicket: OnMergeTicket;
  onGetCartPrice: (cartData?: I_CartItem[]) => void;
  onRemoveTicketList: OnRemoveTicketList;
  ticketsMergedNeedUpdateAmount: MutableRefObject<string[]>;
  paymentMethod: PaymentMethod;
  jumpTicket?: number;
  minAmountTicket?: number;
  allocatedDebt?: number | null;
  setDisableCreateOrder: Dispatch<React.SetStateAction<boolean>>;
  disableCreateOrder: boolean;
}
export enum CART_ERROR_TYPE {
  ERROR_TIME = 'errorTime',
  ERROR_TICKET = 'errorTicket',
  JUMP_TICKET = 'jumpTicket',
  MIN_TICKET = 'minTicket',
}
export type ErrorData = {
  keyItem: string;
  message: string;
  errorType: CART_ERROR_TYPE;
};

type OnGetTicketPrice = (params: {
  ticketData?: {
    show_id?: number;
    date?: string;
    zone_id?: number;
    used_area2?: string | number;
    restaurant_id?: number;
  };
  onMergeTicket?: () => void;
  isUpdateCart?: boolean;
  delay?: number;
  ticketAmount?: number;
}) => void;

const GET_TICKET_PRICE_DELAY = 300;


export const reservationErrorMessages: Record<string, [string, string]> = {
  OUT_OF_CAPACITY: [
    'b2b.cart.error.MSG020',
    'Số vé hiện tại không đủ',
  ],
  STORE_NOT_FOUND: [
    'b2b.cart.error.STORE_NOT_FOUND',
    'Nhà hàng hoặc khu vực đã chọn hiện không nhận đặt chỗ. Vui lòng thử lại hoặc liên hệ CSKH để được hỗ trợ.',
  ],
  ZONE_NOT_FOUND: [
    'b2b.cart.error.ZONE_NOT_FOUND',
    'Nhà hàng hoặc khu vực đã chọn hiện không nhận đặt chỗ. Vui lòng thử lại hoặc liên hệ CSKH để được hỗ trợ.',
  ],
  RESERVATION_NOT_CONFIGURED: [
    'b2b.cart.error.RESERVATION_NOT_CONFIGURED',
    'Nhà hàng hoặc khu vực đã chọn hiện không nhận đặt chỗ. Vui lòng thử lại hoặc liên hệ CSKH để được hỗ trợ.',
  ],
  TIMESLOT_NOT_FOUND: [
    'b2b.cart.error.TIMESLOT_NOT_FOUND',
    'Khung giờ đã chọn không khả dụng. Vui lòng chọn lại.',
  ],
  BOOKING_METHOD_NOT_ENABLED: [
    'b2b.cart.error.BOOKING_METHOD_NOT_ENABLED',
    'Hình thức đặt chỗ chưa được hỗ trợ. Vui lòng thử lại.',
  ],
  BOOKING_METHOD_NOT_CONFIGURED: [
    'b2b.cart.error.BOOKING_METHOD_NOT_CONFIGURED',
    'Hình thức đặt chỗ chưa được hỗ trợ. Vui lòng thử lại.',
  ],
  RESERVATION_SERVICE_FAILED: [
    'b2b.cart.error.RESERVATION_SERVICE_FAILED',
    'Hệ thống đặt chỗ đang gián đoạn. Vui lòng tải lại trang hoặc thử lại sau ít phút.',
  ],
};

  /**
    * 
   * @param error 
   * @param context phải có maxGuestCount, minGuestCount, partySize, với những case lỗi liên quan đến số lượng người
   * và phải có  minAdvanceValue, maxAdvanceValue, minAdvanceUnit, maxAdvanceUnit, date, usedArea2 với những case liên quan đến đặt ngày. usedArea2 là khung giờ đặt bàn, ví dụ 21:00
   * @param t 
   * @returns 
   */
const buildTicketErrorMessage = (
  error: any,
  t: (key: string, fallback: string) => string,
  context?: any,
) => {
  // console.log('getTicketErrorMessage', error, context);
  const errorType =
    typeof error === 'string'
      ? error
      : error?.errorType ?? error?.errorCode ?? error?.code;
  const readParam = (key: string) => {
    const sources = [
      error,
      error?.details,
      error?.data,
      context?.bookingRule,
      context,
      context?.bookingRules,
      context?.booking_rules,
      context?.show,
      context?.product,
      context?.product?.bookingRules,
      context?.product?.booking_rules,
      context?.reservation?.bookingLimits];
    return sources
      .map(source => source?.[key])
      .find(value => value !== undefined && value !== null && value !== '');
  };

  if (reservationErrorMessages[errorType]) {
    const [key, fallback] = reservationErrorMessages[errorType];
    return t(key, fallback);
  }

  if (
    errorType === 'BOOKING_ADVANCE_NOT_MET' ||
    errorType === 'REASON_BOOKING_ADVANCE_NOT_MET'
  ) {
    const getAdvanceMinutes = (value: unknown, unit: unknown) => {
      const numericValue = Number(value ?? 0);
      if (!Number.isFinite(numericValue) || numericValue <= 0) return 0;

      switch (String(unit ?? 'HOUR').toUpperCase()) {
        case 'MINUTE':
          return numericValue;
        case 'DAY':
          return numericValue * 24 * 60;
        default:
          return numericValue * 60;
      }
    };
    const minAdvanceValue = readParam('minAdvanceValue') ?? readParam('min_advance_hours');
    const maxAdvanceValue = readParam('maxAdvanceValue') ?? readParam('max_advance_value');
    const minAdvanceUnit = readParam('minAdvanceUnit') ?? readParam('min_advance_unit');
    const maxAdvanceUnit = readParam('maxAdvanceUnit') ?? readParam('max_advance_unit');
    const date = readParam('date');
    const usedArea2 = readParam('usedArea2') ?? readParam('used_area2');
    const timeMatch = String(usedArea2 ?? '').match(/(\d{1,2}):(\d{2})/);
    const selectedDate = String(date ?? '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const formatAdvanceErrorMessage = (isMaxAdvanceError: boolean) => {
      const advanceValue = isMaxAdvanceError
        ? maxAdvanceValue
        : minAdvanceValue;
      if (advanceValue === undefined) return '';

      const advanceUnit = isMaxAdvanceError ? maxAdvanceUnit : minAdvanceUnit;
      const normalizedAdvanceUnit = String(advanceUnit ?? 'HOUR').toUpperCase();
      const unit = normalizedAdvanceUnit === 'MINUTE'
        ? t('b2b.restaurant.booking.advanceUnit.minute', 'phút')
        : normalizedAdvanceUnit === 'DAY'
          ? 'ngày'
          : t('b2b.restaurant.booking.advanceUnit.hour', 'giờ');
      const message = isMaxAdvanceError
        ? t(
          'b2b.cart.error.MSG070',
          'Vui lòng đặt trước trong thời gian tối đa là `maxAdvanceValue` `maxAdvanceUnit`',
        )
        : t(
          'b2b.cart.error.MSG058',
          'Vui lòng đặt trước trong thời gian tối thiểu là `minAdvanceValue` `minAdvanceUnit`',
        );
      const valuePlaceholder = isMaxAdvanceError
        ? '`maxAdvanceValue`'
        : '`minAdvanceValue`';
      const unitPlaceholder = isMaxAdvanceError
        ? '`maxAdvanceUnit`'
        : '`minAdvanceUnit`';
      return message
        .replace(valuePlaceholder, String(advanceValue))
        .replace(unitPlaceholder, unit);
    };

    if (timeMatch && selectedDate) {
      const [, year, month, day] = selectedDate;
      const targetTime = new Date(
        Number(year), Number(month) - 1, Number(day),
        Number(timeMatch[1]), Number(timeMatch[2]), 0, 0,
      ).getTime();
      if (Number.isFinite(targetTime)) {
        const currentTime = Date.now();
        const minutesUntilSlot = (targetTime - currentTime) / 60000;
        const minMinutes = getAdvanceMinutes(minAdvanceValue, minAdvanceUnit);
        const maxMinutes = getAdvanceMinutes(maxAdvanceValue, maxAdvanceUnit);
        if (minutesUntilSlot > 0) {
          if (maxMinutes > 0 && minutesUntilSlot > maxMinutes) {
            return formatAdvanceErrorMessage(true);
          } else if (minMinutes > 0 && minutesUntilSlot < minMinutes) {
            return formatAdvanceErrorMessage(false);
          }
        } else if (minMinutes > 0) {
          return formatAdvanceErrorMessage(false);
        }
      }
    }

    if (maxAdvanceValue !== undefined && minAdvanceValue === undefined) {
      return formatAdvanceErrorMessage(true);
    }
    if (minAdvanceValue !== undefined && maxAdvanceValue === undefined) {
      return formatAdvanceErrorMessage(false);
    }
    return error?.message ?? '';
  }

  if (
    errorType === 'PARTY_SIZE_OUT_OF_RANGE' ||
    errorType === 'QUANTITY_BELOW_MINIMUM' ||
    errorType === 'QUANTITY_ABOVE_MAXIMUM'
  ) {
    const maxGuestCount = readParam('maxGuestCount');
    const minGuestCount = readParam('minGuestCount');
    const guestCount = context?.partySize ?? Number(context?.amount)
    if (maxGuestCount && guestCount > maxGuestCount) {
      return t(
        'b2b.cart.error.MSG071',
        'Số lượng khách không hợp lệ. Vui lòng nhập tối đa `maxGuestCount` người.',
      ).replace('`maxGuestCount`', String(maxGuestCount))
    }
    if (minGuestCount && guestCount < minGuestCount) {
      return t(
        'b2b.cart.error.MSG060',
        'Số lượng khách không hợp lệ. Vui lòng nhập tối thiểu `minGuestCount` người.',
      ).replace('`minGuestCount`', String(minGuestCount));
    }
  }

  return '';
};

const getStoreListingItems = (response: any): any[] => {
  const payload = response?.data?.data ?? response?.data ?? response;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.items)) return payload.items;
  if (Array.isArray(payload?.stores)) return payload.stores;
  if (Array.isArray(payload?.variants)) return payload.variants;
  return [];
};

export const getTicketErrorMessage = <TStoreEcomID extends string | number | undefined = undefined,>(
  error: any,
  t: (key: string, fallback: string) => string,
  context?: any,
  storeEcomID?: TStoreEcomID,
): TStoreEcomID extends string | number ? Promise<string> : string => {
  if (storeEcomID === undefined || storeEcomID === null || storeEcomID === '') {
    return buildTicketErrorMessage(error, t, context) as any;
  }

  return getReservationBookingStoresApi({ storeId: storeEcomID })
    .then(response => {
      const storeVariant = getStoreListingItems(response).find((item: any) =>
        String(item?.storeId ?? item?.store_id ?? item?.id ?? item?.storeEcomID ?? '') ===
        String(storeEcomID),
      );
      if (!storeVariant) return buildTicketErrorMessage(error, t, context);

      const bookingMethod = getBookingMethodArr(
        storeVariant?.bookingMethods ?? storeVariant?.booking_methods ?? [],
      );
      const rawBookingRules =
        storeVariant?.bookingRules ?? storeVariant?.booking_rules;
      const bookingRule = Array.isArray(rawBookingRules)
        ? rawBookingRules.find(
          (rule: any) => rule?.bookingMethod === bookingMethod,
        ) ?? {}
        : rawBookingRules?.bookingMethod &&
          rawBookingRules.bookingMethod !== bookingMethod
          ? {}
          : rawBookingRules?.[bookingMethod] ?? rawBookingRules ?? {};

      return buildTicketErrorMessage(error, t, {
        ...context,
        bookingRules:bookingRule,
      });
    })
    .catch(() => buildTicketErrorMessage(error, t, context)) as any;
};

const TicketItem = (props: TicketItemProps) => {
  const {
    originalPrice,
    price,
    amount,
    catalog,
    selected,
    date,
    show,
    zone,
    identify,
    created_at,
    errorTicket,
    errorTime,
    itemKey,
    itemKeys,
    inventory,
    sellableQuantity,
    product,
    restaurant,
    usedArea2,
    usedAreas2,
    isSubmitted,
    onSetCart,
    onMergeTicket,
    onGetCartPrice,
    paymentMethod,
    onRemoveTicketList,
    ticketsMergedNeedUpdateAmount,
    jumpTicket,
    minAmountTicket,
    allocatedDebt,
    disableCreateOrder,
    setDisableCreateOrder,
  } = props;

  const dispatch = useDispatch();
  const translations = useSelector(selectTranslations);
  const { onOpenDialogNoti, onCloseDialogNoti } = useGlobalFunction();

  const { device } = useWindowSize();
  const isDesktopScreen = useMemo(() => device === 'desktop', [device]);

  const [triggerValidateRestaurant, setTriggerValidateRestaurant] =
    useState(false);
  const [triggerValidateZone, setTriggerValidateZone] = useState(false);
  const [triggerValidateUsedArea2, setTriggerValidateUsedArea2] =
    useState(false);

  const selectRestaurantPopupContainer = useRef<HTMLDivElement>(null);
  const selectZonePopupContainer = useRef<HTMLDivElement>(null);
  const selectPerformancePopupContainer = useRef<HTMLDivElement>(null);

  const getTicketPriceDelayRef = useRef<ReturnType<typeof setTimeout>>();

  const decrementActionRef = useRef<ReturnType<typeof setTimeout>>();
  const numberControlRef = useRef<{
    setInternalValue: (value: number) => void;
  }>({ setInternalValue: () => { } });
  const currentAmount = useRef(amount);
  const isChangingAmount = useRef(false);

  const infoUser = useSelector(selectInfoUser);
  const isProxyBuyer =
    (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;

  const [warningDialogMsg, setWarningDialogMsg] = useState('');
  const [ticketInventory, setTicketInventory] = useState<null | number>(
    isProxyBuyer ? Infinity : sellableQuantity ?? inventory ?? null,
  );
  const sellableInventory = sellableQuantity ?? inventory;

  const [jumpValue, setJumpValue] = useState(show?.jumpValueB2b ?? 1);
  const [minAmount, setMinAmount] = useState(
    show.minAmountB2b ? +show.minAmountB2b : 0,
  );

  const cartRef = useRef<HTMLDivElement>(null);
  const [cartDOMRect, setCartDOMRect] = useState<DOMRect | null>(null);

  const { partner } = useContext(FormCustomContext);

  const isShowTag = useMemo(() => {
    if (!!partner) {
      return !!partner?.bpLongTerm && !!partner?.allowBuyShortTerm;
    }
    return (
      !!infoUser?.businessPartner?.bpLongTerm &&
      !!infoUser?.businessPartner?.allowBuyShortTerm
    );
  }, [infoUser, partner]);

  useEffect(() => {
    if (amount) numberControlRef.current.setInternalValue(+amount);
  }, [amount]);

  useEffect(() => {
    if (jumpTicket) setJumpValue(jumpTicket);
  }, [jumpTicket]);

  useEffect(() => {
    if (minAmountTicket) setMinAmount(minAmountTicket);
  }, [minAmountTicket]);

  const isComboDifTicket = useMemo(
    () =>
      catalog?.mapVGS === MAP_VGS.COMBO &&
      product?.park?.workstationId === 'DIF',
    [catalog?.mapVGS, product?.park?.workstationId],
  );

  const isRestaurantTicket = useMemo(
    () =>
      show?.restaurants &&
      show?.restaurants?.length > 0 &&
      show?.materialType !== TICKET_TYPES.CABLE_CAR,
    [show?.materialType, show?.restaurants],
  );

  const isCableTicket = useMemo(
    () => show?.materialType === TICKET_TYPES.CABLE_CAR,
    [show?.materialType],
  );

  const isNotApplyZone = useMemo(
    () =>
      show?.materialType === TICKET_TYPES.CABLE_CAR ||
      (show.zones?.length ?? 0) === 0,
    [show?.materialType, show.zones?.length],
  );

  const grandstandData = useMemo(() => {
    const zoneByIdSelected = show?.restaurants?.find(i => i?.id === zone?.id);
    return zoneByIdSelected ?? show?.restaurants?.[0];
  }, [show?.restaurants, zone?.id]);

  const checkEnoughDataToSyncTicket = useCallback(
    (ticketData: {
      amount: number;
      zoneId: number | null | undefined;
      restaurantId: number | null | undefined;
      usedArea2: number | string | null | undefined;
    }) => {
      if (
        !ticketData.amount ||
        (!isNotApplyZone && !ticketData.zoneId) ||
        (!isCableTicket && !ticketData.usedArea2) ||
        (isRestaurantTicket && !ticketData.restaurantId)
      )
        return false;
      return true;
    },
    [isCableTicket, isNotApplyZone, isRestaurantTicket],
  );

  const generateIdentify = useCallback(
    (ticketData: {
      zoneId?: number;
      date?: string;
      restaurantId?: number;
      usedArea2?: string | number;
    }): string => {
      let identify = show.id;
      const partOfIdentity = {
        performanceId: undefined,
        zoneId: zone?.id,
        date,
        restaurantId: restaurant?.id,
        usedArea2: usedArea2,
        ...ticketData,
      };

      for (let key in partOfIdentity) {
        const v = partOfIdentity[key];
        identify += '_';
        if (!!v && v !== 'undefined' && v !== 'null') identify += v;
      }

      return identify;
    },
    [date, restaurant?.id, show.id, usedArea2, zone?.id],
  );

  const handleGetTicketPrice: OnGetTicketPrice = useCallback(
    params => {
      const {
        ticketData,
        onMergeTicket,
        isUpdateCart,
        delay = 0,
        ticketAmount = amount,
      } = params;

      const payloadData = {
        show_id: show?.id,
        date,
        zone_id: zone?.id,
        restaurant_id: restaurant?.id,
        used_area2: usedArea2,
        ...ticketData,
      };

      if (
        (!isCableTicket && !payloadData.used_area2) ||
        (!isNotApplyZone && !payloadData?.zone_id) ||
        (isRestaurantTicket && !payloadData.restaurant_id)
      )
        return false;

      const newIdentify = generateTicketIdentify({
        showId: payloadData.show_id,
        performanceId: undefined,
        zoneId: payloadData.zone_id,
        date: payloadData.date,
        restaurantId: payloadData.restaurant_id,
        usedArea2: payloadData.used_area2,
      });

      const formData = new FormData();
      for (let k in payloadData) {
        formData.append(`items[0][${k}]`, payloadData[k]);
      }
      formData.append(`items[0][payment]`, paymentMethod?.toString() ?? '');
      formData.append(`items[0][amount]`, ticketAmount?.toString() ?? '');

      if (allocatedDebt !== null && allocatedDebt !== undefined)
        formData.append(
          `items[0][bpAllocatedDebt]`,
          allocatedDebt?.toString() ?? '',
        );

      const onError = async (err: any) => {
        const responseError = err?.response?.data ?? err?.data ?? err;
        const errorDetail =
          responseError?.errors?.[0] ?? responseError?.error ?? responseError;
        const message =
          await getTicketErrorMessage(
            errorDetail,
            (key, fallback) => translations?.[key] ?? fallback,
            responseError,
            restaurant?.storeEcomId,
          ) ||
          (errorDetail?.message ?? responseError?.message ?? err?.message);
        if (!message) return;

        onSetCart(prev =>
          prev.map(ticket =>
            ticket.identify === newIdentify
              ? { ...ticket, errorTicket: message }
              : ticket,
          ),
        );
      };

      const onSuccessFully = async responseData => {
        const responseAsObject: Record<string, Record<string, any>> = {};

        responseData?.forEach(item => {
          const identify = generateTicketIdentify({
            showId: item?.show_id,
            performanceId: undefined,
            zoneId: item?.zone_id,
            date: item?.date,
            restaurantId: item?.restaurant?.id ?? item?.restaurant_id,
            usedArea2: item?.used_area2,
          });
          responseAsObject[identify] = item;
        });

        const customMessagesByIdentify = new Map<string, string>();
        await Promise.all((responseData ?? []).map(async item => {
          const itemError = item?.error;
          if (!itemError) return;
          const identify = generateTicketIdentify({
            showId: item?.show_id,
            performanceId: undefined,
            zoneId: item?.zone_id,
            date: item?.date,
            restaurantId: item?.restaurant?.id ?? item?.restaurant_id,
            usedArea2: item?.used_area2,
          });
          const message = await getTicketErrorMessage(
            itemError,
            (key, fallback) => translations?.[key] ?? fallback,
            item,
            item?.restaurant?.storeEcomId ?? item?.storeEcomId ?? restaurant?.storeEcomId,
          );
          customMessagesByIdentify.set(identify, message);
        }));

        let isAnyError = false;

        onSetCart(prev =>
          prev.map(ticket => {
            const ticketResponseData = responseAsObject?.[ticket.identify!];

            if (ticketResponseData) {
              const newInventory = +(isProxyBuyer
                ? Infinity
                : ticketResponseData?.inventory ?? 0);
              const newSellableQuantity = isProxyBuyer
                ? Infinity
                : Number(
                  ticketResponseData?.sellableQuantity ??
                  ticketResponseData?.inventory ??
                  0,
                );
              const err = ticketResponseData?.error;
              const customErrorMessage = customMessagesByIdentify.get(ticket.identify!) ?? '';
              if (!!err) isAnyError = true;
              return {
                ...ticket,
                inventory: newInventory,
                sellableQuantity: newSellableQuantity,
                price: ticketResponseData?.price,
                originalPrice: ticketResponseData?.originalPrice,
                selected: !!+newInventory ? ticket?.selected : false,
                product: {
                  ...ticket.product,
                  isLongTerm: !!ticketResponseData?.isLongTerm,
                },
                errorTime:
                  ticketResponseData?.errorTime ??
                  (err?.errorType === CART_ERROR_TYPE.ERROR_TIME
                    ? err?.message
                    : ''),
                errorTicket:
                  ticketResponseData?.errorTicket ||
                  customErrorMessage ||
                  (err?.errorType === CART_ERROR_TYPE.ERROR_TICKET ||
                    err?.errorType === CART_ERROR_TYPE.JUMP_TICKET ||
                    err?.errorType === CART_ERROR_TYPE.MIN_TICKET
                    ? err?.message
                    : ticketResponseData?.error?.message ?? ''),
              };
            }
            return { ...ticket };
          }),
        );
        if (!isAnyError) onMergeTicket?.();
      };

      if (getTicketPriceDelayRef.current) {
        clearTimeout(getTicketPriceDelayRef.current);
      }

      getTicketPriceDelayRef.current = setTimeout(() => {
        dispatch(
          GET_TICKET_PRICE({
            data: formData,
            ticketIdentify: newIdentify,
            onSuccess: onSuccessFully,
            onError: onError,
            isCallUpdateCartApi: isUpdateCart,
          }),
        );
      }, delay);
    },
    [
      amount,
      date,
      dispatch,
      isCableTicket,
      isNotApplyZone,
      isRestaurantTicket,
      onSetCart,
      paymentMethod,
      restaurant?.id,
      show?.id,
      usedArea2,
      zone?.id,
      allocatedDebt,
      isProxyBuyer,
      translations,
    ],
  );

  const onMergeTicketSuccess = useCallback(
    (response, currentCartData?: I_CartItem[]) => {
      const responseIdentify = generateTicketIdentify({
        showId: response?.show?.id,
        performanceId: undefined,
        zoneId: response?.zone?.id,
        date: response?.date,
        restaurantId: response?.restaurant?.id,
        usedArea2: response?.usedArea2,
      });

      const updateMergedTicket = (item: I_CartItem) => {
        if (item.identify !== responseIdentify) return item;
        return {
          ...item,
          itemKey: response?.itemKey,
          itemKeys: [],
          errorTicket: response?.errorTicket,
          errorTime: response?.errorTime,
          inventory: response?.inventory,
          sellableQuantity: response?.sellableQuantity ?? response?.inventory,
          price: response?.price,
          originalPrice: response?.originalPrice,
          origin: undefined,
        };
      };

      if (!currentCartData?.length) {
        onSetCart(prev => prev.map(updateMergedTicket));
        return;
      }

      const nextCart = currentCartData.map(updateMergedTicket);

      onSetCart(nextCart);
      // Chính sách giá/khuyến mãi có thể phụ thuộc tổng số lượng trong cả giỏ hàng.
      // Merge xong cần gọi lại get-price cho toàn bộ cart để các ticket khác cũng nhận giá mới.
      // Delay sang tick kế tiếp để MERGE_TICKET.success không tắt loading của GET_TICKET_PRICE.
      setTimeout(() => {
        onGetCartPrice(nextCart);
      }, 0);
    },
    [onGetCartPrice, onSetCart],
  );

  const onMergeTicketError = useCallback(
    err => {
      const dataRequest = err?.data?.dataRequest;
      if (dataRequest) {
        const isJumpValueError =
          dataRequest?.errorCode === 'jumpTicket' ||
          dataRequest?.errorCode === 'minTicket';

        const errorIdentify = generateTicketIdentify({
          showId: isJumpValueError ? dataRequest.show_id : dataRequest.showId,
          performanceId: undefined,
          zoneId: isJumpValueError ? dataRequest.zone_id : dataRequest?.zone,
          date: dataRequest?.date,
          restaurantId: isJumpValueError
            ? dataRequest.restaurant_id
            : dataRequest?.restaurant,
          usedArea2: dataRequest?.used_area2,
        });

        if (isJumpValueError) {
          setJumpValue(dataRequest?.jumpTicket ?? jumpValue);
          setMinAmount(dataRequest?.minAmount ?? minAmount);
        }

        onSetCart(prev =>
          prev.map(item => {
            if (item.identify !== errorIdentify) return item;
            const errType = err?.data?.errorType;
            const errMsg = isJumpValueError
              ? dataRequest?.message
              : err?.data?.message ?? err?.message;
            return {
              ...item,
              inventory: err?.data?.inventory ?? item?.inventory ?? 0,
              sellableQuantity:
                err?.data?.sellableQuantity ??
                err?.data?.inventory ??
                item?.sellableQuantity ??
                item?.inventory ??
                0,
              itemKey: err?.data?.keyItem ?? item.itemKey,
              errorTime:
                errType === CART_ERROR_TYPE.ERROR_TIME
                  ? errMsg
                  : item?.errorTime,
              errorTicket:
                errType === CART_ERROR_TYPE.ERROR_TICKET ||
                  errType === CART_ERROR_TYPE.JUMP_TICKET ||
                  errType === CART_ERROR_TYPE.MIN_TICKET
                  ? errMsg
                  : item?.errorTicket,
            };
          }),
        );
      }
    },
    [jumpValue, minAmount, onSetCart],
  );

  const handleChangeUsedArea2 = useCallback(
    (_value, option) => {
      let itemRemoved: I_CartItem | undefined = undefined;
      let newTicketData: I_CartItem | undefined = undefined;
      const newIdentify = generateIdentify({ usedArea2: option.value });

      onSetCart(prev => {
        itemRemoved = prev.find(item => item.identify === newIdentify);

        return prev.reduce((result, item) => {
          switch (true) {
            case newIdentify === item.identify:
              break;
            case identify !== item.identify:
              result.push({ ...item });
              break;
            case identify === item.identify:
            default:
              newTicketData = itemRemoved
                ? {
                  ...itemRemoved,
                  usedArea2: option.value,
                  identify: newIdentify,
                  amount: `${+itemRemoved.amount + +amount}`,
                  itemKey: item?.itemKey,
                  itemKeys: [
                    ...(itemRemoved?.itemKeys ?? []),
                    ...(item?.itemKeys ?? []),
                    item?.itemKey!,
                  ],
                }
                : {
                  ...item,
                  usedArea2: option.value,
                  identify: newIdentify,
                  origin: !item?.origin ? { ...item } : item.origin,
                  itemKeys: [...(item?.itemKeys ?? []), item?.itemKey!],
                };
              result.push(newTicketData);
          }
          return result;
        }, [] as I_CartItem[]);
      });

      currentAmount.current = newTicketData!.amount;
      ticketsMergedNeedUpdateAmount.current = [
        ...ticketsMergedNeedUpdateAmount.current,
        newIdentify,
      ];

      const isEnoughDataToSync = checkEnoughDataToSyncTicket({
        amount: +newTicketData!.amount,
        restaurantId: newTicketData!.restaurant?.id,
        usedArea2: newTicketData!.usedArea2,
        zoneId: newTicketData!.zone?.id,
      });

      const handleOnMergeTicket = () => {
        if (!isEnoughDataToSync) return false;
        onMergeTicket?.(
          {
            show_id: newTicketData!?.show?.id,
            amount: +newTicketData!.amount,
            date: newTicketData!.date,
            used_area2: newTicketData!.usedArea2,
            zone_id: newTicketData!.zone?.id,
            restaurant_id: newTicketData!.restaurant?.id,
            item_keys: newTicketData!?.itemKeys ?? [],
            payment: paymentMethod,
            bpAllocatedDebt: allocatedDebt,
          },
          onMergeTicketSuccess,
          onMergeTicketError,
        );
      };

      handleGetTicketPrice({
        ticketData: {
          used_area2: option?.value,
        },
        onMergeTicket: handleOnMergeTicket,
        isUpdateCart: isEnoughDataToSync,
      });
    },
    [
      amount,
      checkEnoughDataToSyncTicket,
      generateIdentify,
      handleGetTicketPrice,
      identify,
      onMergeTicket,
      onMergeTicketError,
      onMergeTicketSuccess,
      onSetCart,
      paymentMethod,
      ticketsMergedNeedUpdateAmount,
      allocatedDebt,
    ],
  );

  const isLoadedUsedArea2Data = useRef(true);
  const [enableGetUsedArea2, setEnableGetUsedArea2] = useState(false);

  const { getUrlParam } = useSearchParams();
  const ticketTypeParam = getUrlParam('ticketType');

  const displayOriginalPriceFormat = () => {
    let displayStatus: string = PriceDisplayStatus.NA;

    if (isProxyBuyer) {
      return <></>;
    }
    const handleChangeStaus = (
      disableCreateOrderValue: boolean,
      displayStatusValue: string,
    ) => {
      if (selected) {
        setDisableCreateOrder(disableCreateOrderValue);
      }

      displayStatus = displayStatusValue;
    };

    (() => {
      if (_.isNil(originalPrice)) {
        // Không có ngày chọn hoặc không có giá cơ bản sau khi fetch → NA
        handleChangeStaus(true, PriceDisplayStatus.NA);
        return;
      }

      if (_.isNil(price)) {
        // Không có giá bán
        handleChangeStaus(true, PriceDisplayStatus.NA);
        return;
      }

      if (price === 0) {
        // Có CB và B = 0 → Hiển thị CB + B (bình thường) nhưng không mua được
        handleChangeStaus(true, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice > price) {
        // CB > B → Hiển thị CB + B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_BASE_PRICE);
        return;
      }

      if (originalPrice === 0 || originalPrice <= price) {
        // CB == B hoặc CB < B hoặc CB = 0 → chỉ hiển thị B → mua được
        handleChangeStaus(false, PriceDisplayStatus.SHOW_PRICE_ONLY);
        return;
      }

      // Trường hợp còn lại → NA
      handleChangeStaus(true, PriceDisplayStatus.NA);
    })();

    switch (displayStatus) {
      case PriceDisplayStatus.NA:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">N/Ađ</span>
          </div>
        );

      case PriceDisplayStatus.SHOW_BASE_PRICE:
        return (
          <>
            <del className="--price-old">
              {formatNumber(originalPrice || 0)}đ
            </del>
            <div className="--price" style={{ position: 'static', top: 6 }}>
              {formatNumber(price || 0)}đ
            </div>
          </>
        );

      case PriceDisplayStatus.SHOW_PRICE_ONLY:
        return (
          <div className="--price" style={{ position: 'static', top: 6 }}>
            {formatNumber(price || 0)}đ
          </div>
        );

      default:
        return (
          <div className="--price" style={{ position: 'relative', top: 6 }}>
            <span className="--price-na">NAđ</span>
          </div>
        );
    }
  };

  const useGetUsedArea2Options = useMemo(
    () => ({
      payloadData: {
        date,
        show_id: show?.id,
        restaurant_id: restaurant?.id,
        zone_id: zone?.id,
        ticketType: ticketTypeParam,
        ...(allocatedDebt ? { bpAllocatedDebt: allocatedDebt } : {}),
      },
      applyZone: !isNotApplyZone,
      applyUsedZone2: !isCableTicket,
      isRestaurant: isRestaurantTicket,
      IIFE: enableGetUsedArea2,
      onBefore: () => {
        dispatch(cartActions.onSetCartLoading(true));
      },
      onSuccess: response => {
        const haveOnlyOneOption = response.data?.length === 1;

        onSetCart(prev =>
          prev.map(item => {
            if (item.identify !== identify) return item;
            return { ...item, usedAreas2: response.data };
          }),
        );

        if (haveOnlyOneOption) {
          handleChangeUsedArea2(null, {
            label: response.data[0].label,
            value: response.data[0].value,
          });
        }
      },
      onError: () => {
        onSetCart(prev =>
          prev.map(item => {
            if (item.identify !== identify) return item;
            return { ...item, usedAreas2: [] };
          }),
        );
      },
      onFinally: () => {
        dispatch(cartActions.onSetCartLoading(false));
        setEnableGetUsedArea2(false);
        isLoadedUsedArea2Data.current = true;
      },
    }),
    [
      date,
      dispatch,
      enableGetUsedArea2,
      identify,
      isCableTicket,
      isNotApplyZone,
      isRestaurantTicket,
      onSetCart,
      restaurant?.id,
      show?.id,
      zone?.id,
      handleChangeUsedArea2,
      allocatedDebt,
      ticketTypeParam,
    ],
  );

  useGetUsedArea2(useGetUsedArea2Options);

  const isHaveTicketOnSelectedDate = useMemo(
    () =>
      checkHaveTicketOnSelectedDate({
        selectedDate: moment(date, 'YYYY-MM-DD'),
        dateFrom: moment(show?.dateFrom?.dateOrigin, 'YYYY-MM-DD'),
        dateTo: moment(show?.dateTo?.dateOrigin, 'YYYY-MM-DD'),
        isComboDifTicket,
        weekend: show?.weekend,
        fireworkDay: show?.fireworkDay,
      }),
    [
      date,
      isComboDifTicket,
      show?.dateFrom?.dateOrigin,
      show?.dateTo?.dateOrigin,
      show?.weekend,
      show?.fireworkDay,
    ],
  );

  const handleToggleSelect = () => {
    const amountNum = parseFloat(amount);
    const isNotEnoughTickets = !!errorTicket || !!errorTime || !inventory;
    const isEmptyUsedAreas2 = !isCableTicket && (usedAreas2 ?? []).length < 1;

    const isNotEnoughData =
      !amountNum ||
      isNotEnoughTickets ||
      isEmptyUsedAreas2 ||
      !isHaveTicketOnSelectedDate;

    if (isNotEnoughData && !selected) {
      setTriggerValidateUsedArea2(true);
      setTriggerValidateZone(true);
      setTriggerValidateRestaurant(true);
    }

    onSetCart(prev =>
      prev.map(item => {
        if (item.identify !== identify) return item;
        return { ...item, selected: isNotEnoughData ? false : !item.selected };
      }),
    );
  };

  const handleDecrementNumber = () => {
    if (decrementActionRef.current) clearTimeout(decrementActionRef.current);
    if (parseFloat(amount) < 1) return false;
    let newAmount = 0;

    onSetCart(prev =>
      prev.map(item => {
        if (item.identify !== identify) return item;
        newAmount = parseFloat(item.amount) - jumpValue;
        newAmount = newAmount < 0 ? 0 : newAmount;
        return { ...item, amount: newAmount.toString() };
      }),
    );

    currentAmount.current = newAmount.toString();

    if (newAmount === 0) return handleRemove();

    decrementActionRef.current = setTimeout(() => {
      handleGetTicketPrice({
        onMergeTicket: () => {
          onMergeTicket?.(
            {
              show_id: show?.id,
              amount: newAmount,
              date: date,
              zone_id: zone?.id,
              restaurant_id: restaurant?.id,
              item_keys: itemKeys ?? [],
              payment: paymentMethod,
              used_area2: usedArea2,
              bpAllocatedDebt: allocatedDebt ?? null,
            },
            onMergeTicketSuccess,
            onMergeTicketError,
          );
        },
        ticketAmount: newAmount,
        isUpdateCart: true,
      });
    }, GET_TICKET_PRICE_DELAY);
  };

  const handleIncrementNumber = () => {
    let newAmount = 0;
    let invalidAmount = false;

    onSetCart(prev =>
      prev.map(item => {
        if (item.identify !== identify) return item;
        newAmount =
          parseFloat(item.amount) < minAmount
            ? minAmount
            : parseFloat(item.amount) + jumpValue;
        if (newAmount < minAmount) invalidAmount = true;
        return {
          ...item,
          amount: newAmount.toString(),
          selected: invalidAmount ? false : item.selected,
          errorTicket: invalidAmount
            ? translations?.['b2b.txt.minAmount']?.replace(
              '${amount}',
              minAmount,
            ) ?? ''
            : item.errorTicket,
        };
      }),
    );

    if (invalidAmount) return;

    handleGetTicketPrice({
      onMergeTicket: () => {
        onMergeTicket?.(
          {
            show_id: show?.id,
            amount: newAmount,
            date: date,
            zone_id: zone?.id,
            restaurant_id: restaurant?.id,
            item_keys: itemKeys ?? [],
            payment: paymentMethod,
            used_area2: usedArea2,
            bpAllocatedDebt: allocatedDebt ?? null,
          },
          onMergeTicketSuccess,
          onMergeTicketError,
        );
      },
      ticketAmount: newAmount,
      isUpdateCart: true,
      delay: GET_TICKET_PRICE_DELAY,
    });

    currentAmount.current = newAmount.toString();
  };

  const handleOnChangeNumber = (value: number) => {
    const isEmptyAmount = !value;
    isChangingAmount.current = true;
    onSetCart(prev =>
      prev.map(item => {
        if (item.identify !== identify) return item;
        return {
          ...item,
          amount: value.toString(),
          selected: isEmptyAmount ? false : item.selected,
          origin: !item?.origin ? { ...item } : item.origin,
        };
      }),
    );
  };

  const handleOnBlurInputNumber = () => {
    if (+amount % jumpValue !== 0) {
      setWarningDialogMsg(
        translations?.['b2b.txt.onlyAmount']?.replace(
          '${jumpValue}',
          jumpValue,
        ),
      );
      handleOnChangeNumber(+currentAmount.current);
      numberControlRef.current.setInternalValue(+currentAmount.current);
      return;
    }

    const requestedAmount = +amount;
    if (currentAmount.current.toString() === amount.toString()) return;

    if (!requestedAmount) {
      handleRemove();
      return false;
    }

    if (requestedAmount < minAmount) {
      return onSetCart(prev =>
        prev.map(item => {
          if (item.identify !== identify) return item;
          return {
            ...item,
            selected: false,
            errorTicket:
              translations?.['b2b.txt.minAmount']?.replace(
                '${amount}',
                minAmount,
              ) ?? '',
          };
        }),
      );
    }

    handleGetTicketPrice({
      ticketAmount: requestedAmount,
      onMergeTicket: () => {
        onMergeTicket?.(
          {
            show_id: show?.id,
            amount: requestedAmount,
            date: date,
            zone_id: zone?.id,
            restaurant_id: restaurant?.id,
            item_keys: itemKeys ?? [],
            payment: paymentMethod,
            used_area2: usedArea2,
            bpAllocatedDebt: allocatedDebt ?? null,
          },
          onMergeTicketSuccess,
          onMergeTicketError,
        );
      },
      isUpdateCart: true,
    });

    const maxAmount =
      typeof sellableInventory === 'number' && Number.isFinite(sellableInventory)
        ? Math.floor(sellableInventory / jumpValue) * jumpValue
        : undefined;
    const displayAmount =
      maxAmount !== undefined && requestedAmount > maxAmount
        ? maxAmount
        : requestedAmount;
    currentAmount.current = displayAmount.toString();
    if (displayAmount !== requestedAmount) {
      onSetCart(prev =>
        prev.map(item =>
          item.identify === identify
            ? { ...item, amount: displayAmount.toString() }
            : item,
        ),
      );
      numberControlRef.current.setInternalValue(displayAmount);
    }

    isChangingAmount.current = false;
  };

  const handleChangeTime = (_, dateString: string) => {
    const onlyOneRestaurentOption = show?.restaurants?.length === 1;
    const restaurantId = onlyOneRestaurentOption
      ? show?.restaurants?.[0]?.id
      : undefined;

    const onlyOneZoneOption = show?.zones?.length === 1;
    const zoneId = onlyOneZoneOption ? show?.zones?.[0]?.id : undefined;

    const newIdentify = generateIdentify({
      date: dateString,
      usedArea2: undefined,
      zoneId,
      restaurantId,
    });
    let itemRemoved: I_CartItem | undefined = undefined;
    let newTicketData: I_CartItem | null = null;

    setEnableGetUsedArea2(true);

    onSetCart(prev => {
      itemRemoved = prev.find(item => item.identify === newIdentify);

      return prev.reduce((result, item) => {
        switch (true) {
          case newIdentify === item.identify:
            break;
          case identify !== item.identify:
            result.push(item);
            break;
          case identify === item.identify:
          default:
            newTicketData = itemRemoved
              ? {
                ...itemRemoved,
                date: dateString,
                identify: newIdentify,
                amount: `${+itemRemoved.amount + +amount}`,
                created_at: Date.now(),
                errorTicket: '',
                errorTime: '',
                itemKey: item?.itemKey,
                itemKeys: [
                  ...(itemRemoved?.itemKeys ?? []),
                  ...(item?.itemKeys ?? []),
                  item.itemKey!,
                ],
              }
              : {
                ...item,
                identify: newIdentify,
                date: dateString,
                amount: '0',
                created_at: Date.now(),
                errorTicket: '',
                errorTime: '',
                selected: false,
                zone: isNotApplyZone
                  ? null
                  : onlyOneZoneOption
                    ? show?.zones?.[0]
                    : {},
                restaurant: onlyOneRestaurentOption
                  ? show?.restaurants?.[0]
                  : null,
                usedArea2: undefined,
                usedAreas2: [],
                origin: item?.origin ?? item,
                itemKeys: [...(item?.itemKeys ?? []), item?.itemKey!],
              };
            result.push(newTicketData);
        }
        return result;
      }, [] as I_CartItem[]);
    });

    if (!itemRemoved) isLoadedUsedArea2Data.current = false;

    currentAmount.current = newTicketData!.amount;
    ticketsMergedNeedUpdateAmount.current = [
      ...ticketsMergedNeedUpdateAmount.current,
      newIdentify,
    ];

    const isEnoughDataToSync = checkEnoughDataToSyncTicket({
      amount: +newTicketData!.amount,
      restaurantId: newTicketData!.restaurant?.id,
      usedArea2: newTicketData!.usedArea2,
      zoneId: newTicketData!.zone?.id,
    });

    const handleOnMergeTicket = () => {
      if (!isEnoughDataToSync) return false;
      onMergeTicket?.(
        {
          show_id: newTicketData!?.show?.id,
          amount: +newTicketData!.amount,
          date: newTicketData!.date,
          used_area2: newTicketData!.usedArea2,
          zone_id: newTicketData!.zone?.id,
          item_keys: newTicketData!?.itemKeys ?? [],
          restaurant_id: newTicketData!.restaurant?.id,
          payment: paymentMethod,
          bpAllocatedDebt: allocatedDebt,
        },
        onMergeTicketSuccess,
        onMergeTicketError,
      );
    };

    handleGetTicketPrice({
      ticketData: {
        date: dateString,
        zone_id: undefined,
        used_area2: undefined,
        restaurant_id: undefined,
      },
      onMergeTicket: handleOnMergeTicket,
      isUpdateCart: isEnoughDataToSync,
    });
  };

  const handleChangeRestaurant = (_value, option) => {
    const newIdentify = generateIdentify({
      restaurantId: option?.id,
      usedArea2: undefined,
    });
    let itemRemoved: I_CartItem | undefined = undefined;
    let newTicketData: I_CartItem | null = null;

    setEnableGetUsedArea2(true);

    onSetCart(prev => {
      itemRemoved = prev.find(i => i.identify === newIdentify);

      return prev.reduce((result, item) => {
        switch (true) {
          case newIdentify === item.identify:
            break;
          case identify !== item.identify:
            result.push(item);
            break;
          case identify === item.identify:
          default:
            newTicketData = itemRemoved
              ? {
                ...itemRemoved,
                restaurant: option,
                identify: newIdentify,
                amount: `${+itemRemoved.amount + +amount}`,
                created_at: Date.now(),
                errorTicket: '',
                errorTime: '',
                itemKey: item?.itemKey,
                itemKeys: [
                  ...(itemRemoved?.itemKeys ?? []),
                  ...(item?.itemKeys ?? []),
                  item.itemKey!,
                ],
              }
              : {
                ...item,
                restaurant: option,
                identify: newIdentify,
                amount: '0',
                created_at: Date.now(),
                errorTicket: '',
                errorTime: '',
                zone: null,
                usedArea2: undefined,
                usedAreas2: [],
                origin: item?.origin ?? item,
                itemKeys: [...(item?.itemKeys ?? []), item?.itemKey!],
              };
            result.push(newTicketData);
        }
        return result;
      }, [] as I_CartItem[]);
    });

    if (!itemRemoved) isLoadedUsedArea2Data.current = false;

    currentAmount.current = newTicketData!.amount;
    ticketsMergedNeedUpdateAmount.current = [
      ...ticketsMergedNeedUpdateAmount.current,
      newIdentify,
    ];
  };

  const handleChangeZone = (_value, option) => {
    const newIdentify = generateIdentify({
      zoneId: option?.id,
      usedArea2: undefined,
    });
    let itemRemoved: I_CartItem | undefined = undefined;
    let newTicketData: I_CartItem | null = null;

    setEnableGetUsedArea2(true);

    onSetCart(prev => {
      itemRemoved = prev.find(i => i.identify === newIdentify);

      return prev.reduce((result, item) => {
        switch (true) {
          case newIdentify === item.identify:
            break;
          case identify !== item.identify:
            result.push(item);
            break;
          case identify === item.identify:
          default:
            newTicketData = itemRemoved
              ? {
                ...itemRemoved,
                zone: option,
                identify: newIdentify,
                amount: `${+itemRemoved.amount + +amount}`,
                created_at: Date.now(),
                errorTicket: '',
                errorTime: '',
                itemKey: item?.itemKey,
                itemKeys: [
                  ...(itemRemoved?.itemKeys ?? []),
                  ...(item?.itemKeys ?? []),
                  item.itemKey!,
                ],
              }
              : {
                ...item,
                zone: option,
                identify: newIdentify,
                created_at: Date.now(),
                errorTicket: '',
                errorTime: '',
                usedArea2: undefined,
                usedAreas2: [],
                origin: !item?.origin ? { ...item } : item.origin,
                itemKeys: [...(item?.itemKeys ?? []), item?.itemKey!],
              };
            result.push(newTicketData);
        }
        return result;
      }, [] as I_CartItem[]);
    });

    if (!itemRemoved) isLoadedUsedArea2Data.current = false;

    currentAmount.current = newTicketData!.amount;
    ticketsMergedNeedUpdateAmount.current = [
      ...ticketsMergedNeedUpdateAmount.current,
      newIdentify,
    ];
  };

  const convertDataOption = (arr, type) => {
    let result = [];
    if (arr?.length) {
      result = arr.map(item => ({
        ...item,
        value: type === 'usedArea2' ? item.value : item.id,
        label: type === 'usedArea2' ? item.label : item?.name,
      }));
    }
    return result;
  };

  const handleRemove = () => {
    onOpenDialogNoti({
      type: 'ERROR',
      isShow: true,
      title: '',
      content: translations?.['b2b.txt.cfRemoveTicket'] ?? '',
      closable: false,
      buttons: [
        {
          text: translations?.['b2b.btn.cancel'] ?? '',
          bg: '#ffff',
          border: 'solid 1px #808080',
          color: '#808080',
          onClick: () => {
            onSetCart(prev =>
              prev.map(item =>
                item.identify === identify
                  ? { ...item, amount: '1', selected: true }
                  : item,
              ),
            );
            currentAmount.current = '1';
            numberControlRef.current.setInternalValue(1);
            onCloseDialogNoti();
          },
        },
        {
          text: translations?.['b2b.btn.delete'] ?? '',
          bg: 'linear-gradient(79.97deg, #F06F24 -7.79%, #F8B117 107.61%)',
          color: 'white',
          onClick: () => {
            const onRemoveSuccess = () => {
              onSetCart(prev => prev.filter(item => item.itemKey !== itemKey));
            };
            onRemoveTicketList(
              [props?.origin?.itemKey ?? itemKey ?? '', ...(itemKeys ?? [])],
              onRemoveSuccess,
            );
            onCloseDialogNoti();
          },
        },
      ],
    });
  };

  useEffect(() => {
    if (isSubmitted && selected) {
      setTriggerValidateUsedArea2(true);
      setTriggerValidateZone(true);
      setTriggerValidateRestaurant(true);
    }
  }, [isSubmitted, selected]);

  useEffect(() => {
    const setInventoryToUndefined = () => {
      if (inventory === undefined) return;
      onSetCart(prev =>
        prev.map(item => {
          if (item.identify !== identify) return item;
          return {
            ...item,
            inventory: undefined,
            sellableQuantity: undefined,
          };
        }),
      );
    };

    if (
      !date ||
      (!isCableTicket && !usedArea2) ||
      (!isNotApplyZone && !zone?.id)
    ) {
      setTicketInventory(isProxyBuyer ? Infinity : null);
      setInventoryToUndefined();
    }
  }, [
    date,
    identify,
    inventory,
    isCableTicket,
    isNotApplyZone,
    onSetCart,
    usedArea2,
    zone?.id,
    isProxyBuyer,
  ]);

  useEffect(() => {
    const availableQuantity = sellableQuantity ?? inventory;
    if (typeof availableQuantity === 'number') {
      setTicketInventory(isProxyBuyer ? Infinity : availableQuantity);
    }
  }, [inventory, isProxyBuyer, sellableQuantity]);

  useLayoutEffect(() => {
    const idx = ticketsMergedNeedUpdateAmount.current.indexOf(identify!);
    if (idx > -1) {
      numberControlRef.current.setInternalValue(+amount!);
      ticketsMergedNeedUpdateAmount.current.splice(idx, 1);
    }
  });

  useLayoutEffect(() => {
    const onSetGroupTicketDetailDOMRect = () => {
      if (!cartRef.current) return;
      setCartDOMRect(cartRef.current.getBoundingClientRect());
    };

    onSetGroupTicketDetailDOMRect();

    window.addEventListener('resize', onSetGroupTicketDetailDOMRect);

    return () => {
      window.removeEventListener('resize', onSetGroupTicketDetailDOMRect);
    };
  }, []);

  return (
    <>
      <TicketContainer
        gutter={33}
        style={{ flexDirection: isDesktopScreen ? 'row' : 'column' }}
        id={identify!}
      >
        <Col span={isDesktopScreen ? 5 : 24}>
          {show?.image?.original ? (
            <Thumb src={show?.image?.original} />
          ) : (
            <StyledDefaultImg />
          )}
        </Col>
        <Col span={isDesktopScreen ? 19 : 24}>
          {isDesktopScreen ? (
            <Row
              justify="space-between"
              style={{
                flexWrap: 'nowrap',
                flexDirection: 'row',
              }}
            >
              <Col
                style={{
                  maxWidth: 'calc(100% - 216px)',
                }}
              >
                <TicketName>{catalog?.name}</TicketName>
              </Col>
              <Col
                style={{
                  flexShrink: 0,
                  marginLeft: 10,
                  display: 'block',
                  marginTop: 0,
                }}
              >
                {!isDesktopScreen && (
                  <Time>
                    <p className="time-title">
                      {translations?.['b2b.txt.date-order']}{' '}
                      <span className="booking-time">
                        {moment
                          .unix(
                            parseFloat((created_at ?? 0)?.toString()) / 1000,
                          )
                          .format('DD/MM/YYYY')}
                      </span>
                    </p>
                  </Time>
                )}
                <Time>
                  <StyledCheckbox
                    checked={selected}
                    onClick={handleToggleSelect}
                  >
                    <p className="time-title">
                      {translations?.['b2b.txt.date-order']}{' '}
                      <span className="booking-time">
                        {moment
                          .unix(
                            parseFloat((created_at ?? 0)?.toString()) / 1000,
                          )
                          .format('DD/MM/YYYY')}
                      </span>
                    </p>
                  </StyledCheckbox>
                </Time>
              </Col>
            </Row>
          ) : (
            <Row
              justify="space-between"
              style={{
                flexWrap: 'nowrap',
                flexDirection: 'column',
              }}
            >
              <Col
                style={{
                  flexShrink: 0,
                  marginLeft: 0,
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: 16,
                }}
              >
                <Time>
                  <p className="time-title">
                    {translations?.['b2b.txt.date-order']}{' '}
                    <span className="booking-time">
                      {moment
                        .unix(parseFloat((created_at ?? 0)?.toString()) / 1000)
                        .format('DD/MM/YYYY')}
                    </span>
                  </p>
                </Time>
                <Time>
                  <TrashIcon
                    style={{ cursor: 'pointer', marginRight: 16 }}
                    onClick={handleRemove}
                  />
                  <StyledCheckbox
                    checked={selected}
                    onClick={handleToggleSelect}
                  />
                </Time>
              </Col>
              <Col
                style={{
                  maxWidth: 'auto',
                }}
              >
                <TicketName>{catalog?.name}</TicketName>
              </Col>
            </Row>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Catalog>{show?.name}</Catalog>
            {isShowTag && (
              <div
                style={{
                  marginBottom: '5px',
                  padding: '4px 8px',
                  whiteSpace: 'nowrap',
                  background: '#F54949',
                  borderRadius: '8px',
                  color: 'white',
                  height: '25px',
                  fontSize: '12px',
                }}
              >
                {
                  translations?.[
                  `${product?.isLongTerm
                    ? 'b2b.txt.long-term'
                    : 'b2b.txt.short-term'
                  }`
                  ]
                }
              </div>
            )}
          </div>
          <div>
            <Row gutter={32}>
              <Col span={isDesktopScreen ? 9 : 24}>
                <div
                  style={{
                    position: 'relative',
                    marginTop: isDesktopScreen ? 0 : 8,
                  }}
                >
                  <CustomDatePicker
                    value={moment(date, 'YYYY-MM-DD')}
                    format="YYYY-MM-DD"
                    isComboDiffTicket={isComboDifTicket}
                    showDateFrom={show?.dateFrom}
                    showDateTo={show?.dateTo}
                    weekend={show?.weekend}
                    onChange={handleChangeTime}
                    isError={
                      (!isCableTicket &&
                        isLoadedUsedArea2Data.current &&
                        (usedAreas2 ?? []).length < 1) ||
                      !!errorTime ||
                      !!errorTicket ||
                      !isHaveTicketOnSelectedDate
                    }
                    fireworkDay={show?.fireworkDay}
                  />
                  {(!isCableTicket &&
                    isLoadedUsedArea2Data.current &&
                    (usedAreas2 ?? []).length < 1) ||
                    !!errorTime ||
                    !!errorTicket ||
                    !isHaveTicketOnSelectedDate ? (
                    <ErrMess>
                      {errorTime ||
                        errorTicket ||
                        translations?.['b2c.txt.detail-show-no-performance']}
                    </ErrMess>
                  ) : null}
                </div>
              </Col>
              {isDesktopScreen && (
                <PriceWrapper>
                  <PriceBLock>{displayOriginalPriceFormat()}</PriceBLock>
                </PriceWrapper>
              )}
              {isDesktopScreen && (
                <Col>
                  <NumberControl
                    number={parseFloat(amount)}
                    onDecrement={handleDecrementNumber}
                    onIncrement={handleIncrementNumber}
                    onChange={handleOnChangeNumber}
                    disabledMinus={parseFloat(amount) <= minAmount}
                    onBlur={handleOnBlurInputNumber}
                    disablePlus={
                      (isNotApplyZone ? false : !zone?.id) ||
                      (isCableTicket ? false : !usedArea2) ||
                      ((usedAreas2 ?? []).length < 1 && !isCableTicket) ||
                      +amount >=
                      Math.floor((sellableInventory ?? 0) / jumpValue) * jumpValue
                    }
                    inputReadOnly={
                      (isNotApplyZone ? false : !zone?.id) ||
                      (isCableTicket ? false : !usedArea2) ||
                      ((usedAreas2 ?? []).length < 1 && !isCableTicket)
                    }
                    min={0}
                    max={
                      isProxyBuyer
                        ? Infinity
                        : isChangingAmount.current
                          ? Math.floor(ticketInventory! / jumpValue) * jumpValue
                          : undefined
                    }
                    ref={numberControlRef}
                    step={jumpValue}
                    lowerLimit={minAmount}
                  />
                </Col>
              )}
            </Row>
          </div>
          {!isCableTicket || isDesktopScreen ? (
            <div ref={cartRef}>
              <PositionAndTimeBlock gutter={isDesktopScreen ? 24 : 16}>
                <Col span={isDesktopScreen ? 6 : 12}>
                  {isRestaurantTicket && !isCableTicket ? (
                    <>
                      <SelectPopupContainer
                        ref={selectRestaurantPopupContainer}
                        popupMaxWidth={
                          !!cartDOMRect?.width
                            ? `${cartDOMRect?.width}px`
                            : undefined
                        }
                        popupWidth={
                          device === 'desktop'
                            ? 'initial'
                            : !!cartDOMRect?.width
                              ? `${cartDOMRect?.width}px`
                              : undefined
                        }
                      />
                      <StyledSelect
                        options={
                          convertDataOption(
                            show?.restaurants ?? [],
                            'restaurant',
                          ) ?? []
                        }
                        dropdownRender={menu => (
                          <div className="custom-dropdown">{menu}</div>
                        )}
                        virtual={false}
                        value={restaurant?.id}
                        onChange={handleChangeRestaurant}
                        placeholder={
                          show.usedArea1Label ||
                          translations?.['b2c.text.restaurants'] ||
                          ''
                        }
                        onBlur={() => setTriggerValidateRestaurant(true)}
                        getPopupContainer={() =>
                          selectRestaurantPopupContainer.current!
                        }
                        suffixIcon={<ArrowDownIcon />}
                        isError={triggerValidateRestaurant && !restaurant?.id}
                      />
                      {triggerValidateRestaurant && !restaurant?.id && (
                        <ErrMess>
                          {`${translations?.['b2c.txt.plsChoose']} ${show?.usedArea1Label?.toLowerCase() ?? ''
                            }`}
                        </ErrMess>
                      )}
                    </>
                  ) : null}
                </Col>

                {!isCableTicket ? (
                  <>
                    {!isNotApplyZone ? (
                      <Col span={isDesktopScreen ? 6 : 12}>
                        {isNotApplyZone ? null : (
                          <>
                            <SelectPopupContainer
                              ref={selectZonePopupContainer}
                              popupMaxWidth={
                                !!cartDOMRect?.width
                                  ? `${cartDOMRect?.width}px`
                                  : undefined
                              }
                              popupWidth={
                                device === 'desktop'
                                  ? 'initial'
                                  : !!cartDOMRect?.width
                                    ? `${cartDOMRect?.width}px`
                                    : undefined
                              }
                            />
                            <StyledSelect
                              options={
                                convertDataOption(show?.zones ?? [], 'zone') ??
                                []
                              }
                              dropdownRender={menu => (
                                <div className="custom-dropdown">{menu}</div>
                              )}
                              virtual={false}
                              value={zone?.id}
                              onChange={handleChangeZone}
                              placeholder={translations?.['b2c.txt.zone']}
                              onBlur={() => setTriggerValidateZone(true)}
                              getPopupContainer={() =>
                                selectZonePopupContainer.current!
                              }
                              suffixIcon={<ArrowDownIcon />}
                              isError={triggerValidateZone && !zone?.id}
                              placement={
                                device !== 'desktop'
                                  ? 'bottomRight'
                                  : 'bottomLeft'
                              }
                            />
                            {triggerValidateZone && !zone?.id && (
                              <ErrMess>
                                {translations?.['b2b.txt.validateZone']}
                              </ErrMess>
                            )}
                          </>
                        )}
                      </Col>
                    ) : (
                      <Col span={0}></Col>
                    )}

                    <Col span={isDesktopScreen ? 6 : 12}>
                      {isCableTicket ? null : (
                        <>
                          <SelectPopupContainer
                            ref={selectPerformancePopupContainer}
                            popupMaxWidth={
                              !!cartDOMRect?.width
                                ? `${cartDOMRect?.width}px`
                                : undefined
                            }
                            popupWidth={
                              device === 'desktop'
                                ? 'initial'
                                : !!cartDOMRect?.width
                                  ? `${cartDOMRect?.width}px`
                                  : undefined
                            }
                          />
                          <StyledSelect
                            options={
                              convertDataOption(
                                usedAreas2 ?? [],
                                'usedArea2',
                              ) ?? []
                            }
                            dropdownRender={menu => (
                              <div className="custom-dropdown">{menu}</div>
                            )}
                            virtual={false}
                            value={usedArea2}
                            onChange={handleChangeUsedArea2}
                            placeholder={
                              show?.usedArea2Label ||
                              translations?.['b2c.txt.hours'] ||
                              ''
                            }
                            onBlur={() => setTriggerValidateUsedArea2(true)}
                            getPopupContainer={() =>
                              selectPerformancePopupContainer.current!
                            }
                            suffixIcon={<ArrowDownIcon />}
                            isError={triggerValidateUsedArea2 && !usedArea2}
                            placement={
                              device !== 'desktop' && !!isNotApplyZone
                                ? 'bottomRight'
                                : 'bottomLeft'
                            }
                          />
                          {triggerValidateUsedArea2 && !usedArea2 && (
                            <ErrMess>
                              {`${translations?.['b2c.txt.plsChoose']} ${show?.usedArea2Label?.toLowerCase() ?? ''
                                }`}
                            </ErrMess>
                          )}
                        </>
                      )}
                    </Col>
                  </>
                ) : null}
                {isDesktopScreen ? (
                  <Col
                    offset={
                      (2 -
                        [
                          !isCableTicket,
                          !isNotApplyZone,
                          isRestaurantTicket,
                        ].filter(i => i).length) *
                      6
                    }
                  >
                    <div
                      style={{
                        marginLeft: 65,
                        paddingTop: 4,
                      }}
                    >
                      {ticketInventory !== null && !isProxyBuyer && (
                        <Inventory
                          inventory={ticketInventory!}
                          styles={{ maxWidth: 200 }}
                        />
                      )}
                    </div>
                  </Col>
                ) : null}
              </PositionAndTimeBlock>
            </div>
          ) : null}

          {!isDesktopScreen && (
            <>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'space-between',
                  marginTop: 16,
                }}
              >
                <GrandstandDiagram
                  grandstandData={grandstandData}
                  textCSS={{ marginTop: 0 }}
                />
                {ticketInventory !== null && !isProxyBuyer && (
                  <Inventory inventory={ticketInventory!} />
                )}
              </div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  marginTop: 16,
                }}
              >
                <PriceWrapper>
                  <PriceBLock>{displayOriginalPriceFormat()}</PriceBLock>
                </PriceWrapper>
                <div className="d-flex flex-column align-items-end">
                  <NumberControl
                    number={parseFloat(amount)}
                    onDecrement={handleDecrementNumber}
                    onIncrement={handleIncrementNumber}
                    disabledMinus={parseFloat(amount) <= minAmount}
                    onChange={handleOnChangeNumber}
                    disablePlus={
                      (isNotApplyZone ? false : !zone?.id) ||
                      (isCableTicket ? false : !usedArea2) ||
                      ((usedAreas2 ?? []).length < 1 && !isCableTicket) ||
                      +amount >=
                      Math.floor((sellableInventory ?? 0) / jumpValue) * jumpValue
                    }
                    inputReadOnly={
                      (isNotApplyZone ? false : !zone?.id) ||
                      (isCableTicket ? false : !usedArea2) ||
                      ((usedAreas2 ?? []).length < 1 && !isCableTicket)
                    }
                    onBlur={handleOnBlurInputNumber}
                    min={0}
                    max={
                      isProxyBuyer
                        ? Infinity
                        : isChangingAmount.current
                          ? Math.floor(ticketInventory! / jumpValue) * jumpValue
                          : undefined
                    }
                    ref={numberControlRef}
                    step={jumpValue}
                    lowerLimit={minAmount}
                  />
                </div>
              </div>
            </>
          )}

          <RenderIf condition={isDesktopScreen}>
            <Row justify="space-between">
              <Col>
                <GrandstandDiagram grandstandData={grandstandData} />
              </Col>
              <Col>
                <TrashIcon
                  style={{ cursor: 'pointer' }}
                  onClick={handleRemove}
                />
              </Col>
            </Row>
          </RenderIf>
        </Col>
      </TicketContainer>
      <DialogWarning
        open={!!warningDialogMsg}
        message={warningDialogMsg}
        onClose={() => {
          setWarningDialogMsg('');
        }}
      />
    </>
  );
};

export default React.memo(
  TicketItem,
  (prevProps, nextProps) =>
    JSON.stringify(prevProps) === JSON.stringify(nextProps),
);
